// Français pour le chat d'ébauche des modales (la coque parle via AgentFlyout.fr.ts).
import { registerFr } from '../i18n/index.js';

registerFr({
  'Draft with the agent': 'Rédiger avec l’agent',
  'agent · proposes into the fields, a take fills the form': 'agent · propose dans les champs, seule la reprise remplit le formulaire',
  'Discuss what belongs in the fields. The agent reads the engagement, proposes text per field, and you steer — a proposal lands only when you take it.':
    'Discutez de ce qui va dans les champs. L’agent lit le mandat, propose un texte par champ, et vous pilotez — une proposition n’atterrit que lorsque vous la reprenez.',
  'Take into {field}': 'Reprendre dans {field}',
  'e.g. “Draft a checkable definition of done”': 'p. ex. « Rédige des critères d’acceptation vérifiables »',
  'The agent did not answer.': 'L’agent n’a pas répondu.',
}, 'FieldChat');
